<template>
    <span class="p-float-label">
        <InputNumber
            :modelValue="value"
            id="cand-count"
            @blur="$emit('handleValueChange', parseInt(monitorValue($event.value)))"
            :min="0"
            :max="maxValue"
        />
        <label v-if="maxValue" for="cand-count">Number from 0 to {{ maxValue }}</label>
        <label v-if="!maxValue" for="cand-count">Enter candidates first</label>
    </span>
</template>

<script>
export default {
    name: 'DistinctDonationsBasketRule',
    props: ['value', 'maxValue'],
    emits: ['handleValueChange'],
    methods: {
        monitorValue(val) {
            if (!this.maxValue) {
                return null;
            }
            if (val > this.maxValue) {
                return this.maxValue;
            }
            return val;
        },
    },
};
</script>

<style scoped></style>
